export enum NotificationTypes {
  Info = 'Info',
  Success = 'Success',
  Ok = 'Ok',
  Warning = 'Warning',
  Error = 'Error',
}
